<mat-form-field customColor="light" appearance="outline"
  [class.focus]="autocompleteTrigger && autocompleteTrigger.panelOpen">
  <mat-label>País</mat-label>
  <input matInput #countryInput placeholder="Selecciona uno" maxlength="30" [formControl]="searchControl"
    [errorStateMatcher]="errorStateMatcher" name="countryId" autocomplete="off" [matAutocomplete]="auto" />
  @if (countryControl.value && countryControl.value.countryId && getFlagFromCountryId(countryControl.value.countryId)) {
  <img matPrefix [src]="getFlagFromCountryId(countryControl.value.countryId)" class="flag"
    alt="Bandera del país seleccionado" />
  }
  <mat-autocomplete #auto="matAutocomplete" (opened)="onPanelOpened()" (closed)="onPanelClosed()"
    (optionSelected)="onOptionSelected($event)">
    @for (country of filteredCountriesList; track country.countryId) {
    <mat-option [value]="country">
      <div class="country-option">
        @if (country.flag) {
        <div class="flag">
          <img [src]="country.flag" alt="Bandera de {{ country.name }}" />
        </div>
        }
        <span>{{ country.name }}</span>
      </div>
    </mat-option>
    }
    @if (filteredCountriesList.length === 0) {
    <mat-option disabled value="">No hay resultados</mat-option>
    }
  </mat-autocomplete>
  @if (countryControl.value) {
  <mat-icon matSuffix class="clear-icon" (click)="clearSelection($event)">close</mat-icon>
  } @else {
  <mat-icon matSuffix>expand_more</mat-icon>
  }
  <mat-error>Debes seleccionar un país</mat-error>
</mat-form-field>